import React, {useEffect, useRef, useState} from 'react';
import {TextInputMaskProps} from 'react-native-text-input-mask';
import theme from '../../../../../global/styles/legacy/theme';

import {
  Container,
  InputContainer,
  Input,
  Error,
  Label,
  FormControl,
  Form,
} from './styles';

interface IAuthInput extends TextInputMaskProps {
  error?: string;
  errorStyle?: boolean;
  passwordInput?: boolean;
  onChangeDate: (value: string) => void;
  enabled: (value: boolean) => void;
}

export function BirthInput({
  error,
  errorStyle = false,
  enabled,
  onChangeDate,
  ...rest
}: IAuthInput) {
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  const monthInput = useRef<any>(null);
  const yearInput = useRef<any>(null);

  function handleDayChangeText(value: string) {
    setDay(value.replace(/\D/g, ''));
  }

  function handleMonthChangeText(value: string) {
    setMonth(value.replace(/\D/g, ''));
  }

  function handleYearChangeText(value: string) {
    setYear(value.replace(/\D/g, ''));
  }

  useEffect(() => {
    const hasAnyValue = day.length > 0 || month.length > 0 || year.length > 0;
    const date = day + '/' + month + '/' + year;

    if (!hasAnyValue) {
      // Não digitou nada -> campo não é obrigatório
      enabled(true); // ou false, dependendo se "enabled" significa permitir submit
      onChangeDate('');
      return;
    }

    // Se começou a digitar (pelo menos o dia), agora vira obrigatório
    if (day.length < 2) {
      enabled(false);
      return;
    } else {
      monthInput.current?.focus();
    }

    if (month.length < 2) {
      enabled(false);
      return;
    } else {
      yearInput.current?.focus();
    }

    if (year.length < 4) {
      enabled(false);
      return;
    }

    // Se chegou aqui, todos os campos estão válidos
    enabled(true);
    onChangeDate(date);
  }, [day, month, year]);

  return (
    <Container>
      <Label>Data de nascimento</Label>
      <Form>
        <FormControl style={{marginLeft: 0}}>
          <InputContainer error={errorStyle}>
            <Input
              error={errorStyle}
              value={day}
              onChangeText={handleDayChangeText}
              maxLength={2}
              keyboardType="number-pad"
              placeholder="Dia"
              placeholderTextColor={theme.colors.placeholder}
            />
          </InputContainer>
        </FormControl>
        <FormControl>
          <InputContainer error={errorStyle}>
            <Input
              error={errorStyle}
              value={month}
              ref={monthInput}
              onChangeText={handleMonthChangeText}
              placeholder="Mês"
              maxLength={2}
              keyboardType="number-pad"
              placeholderTextColor={theme.colors.placeholder}
            />
          </InputContainer>
        </FormControl>
        <FormControl>
          <InputContainer error={errorStyle}>
            <Input
              {...rest}
              error={errorStyle}
              value={year}
              ref={yearInput}
              placeholder="Ano"
              onChangeText={handleYearChangeText}
              keyboardType="number-pad"
              maxLength={4}
              placeholderTextColor={theme.colors.placeholder}
            />
          </InputContainer>
        </FormControl>
      </Form>
      {error ? <Error>{error}</Error> : <></>}
    </Container>
  );
}
